/** @jsx jsx */
import Img from 'gatsby-image';
import { Box, Heading, Text, jsx } from 'theme-ui';
import styles from './category-banner.style';
// demo data
import bannerImg from '../../images/category-banner.png';

type PropsType = {
	title?: string;
	subtitle?: string;
	bgImage?: any;
};

const CategoryBanner: React.FC<PropsType> = ({ title, subtitle, bgImage }) => {
	const bgBannerImg = bgImage?.localFile?.childImageSharp?.fluid || bannerImg;
	return (
		<Box as="section" sx={styles.wrapper}>
			<Img fluid={bgBannerImg} />
			<Box as="header" sx={styles.bannerContent}>
				<Heading as="h1">{title}</Heading>
				{subtitle && <Text as="p">{subtitle}</Text>}
			</Box>
		</Box>
	);
};

export default CategoryBanner;
